import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Footer.css';

const Footer: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const scrollTo = (id: string) => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    } else {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      <div className="footer-inner">

        <div className="footer-brand">
          <h3>CABnHAUL</h3>
          <p>Personalized Premier Transportation</p>
          <p className="footer-service-area">Serving Bucks County &amp; Greater Philadelphia</p>
        </div>

        <div className="footer-links">
          <h4>Quick Links</h4>
          <ul>
            <li><button onClick={() => scrollTo('services')}>Services</button></li>
            <li><button onClick={() => scrollTo('testimonials')}>Testimonials</button></li>
            <li><a href="/contact">Contact</a></li>
          </ul>
        </div>

        <div className="footer-contact">
          <h4>Contact Us</h4>
          <a href="mailto:CabnHaul@gmail.com">CabnHaul@gmail.com</a>
          <a href="tel:+12153843448">(215) 384-3448</a>
        </div>

      </div>
      <div className="footer-bottom">
        <p>© 2025 CABnHAUL. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
